/**
 * @file 具有轮询效果的gas费行展示
 */
import { useFm } from '@web3/base-hooks';
import { Row } from '../normal';
import { Circle } from 'rc-progress';
import { formatUSDYield } from '@/utils/num';
import cls from 'classnames';

import styles from './index.module.scss';

interface Props {
  className?: string;
  show: boolean;
  gasStore: {
    loopPercent: number;
    symbol: string;
    price: string;
    amount: string;
  };
  showArrow?: boolean;
  onClickArrow?: () => void;
}

export const GasCircleRow = (props: Props) => {
  const { className, show, gasStore, showArrow, onClickArrow } = props;
  const fm = useFm();
  return (
    <Row
      className={className}
      show={show}
      label={fm('estimated_cost')}
      value={
        <div className={styles.gasfee}>
          <Circle
            className={styles.circle}
            percent={gasStore.loopPercent}
            trailWidth={10}
            strokeWidth={10}
            trailColor="rgba(247, 166, 0, 0.16)"
            strokeColor="#F7A600"
          />
          <div>
            {`${gasStore.amount} ${gasStore.symbol} (${formatUSDYield(gasStore.price)})`}
          </div>
        </div>
      }
      showArrow={showArrow}
      onClickArrow={onClickArrow}
    />
  );
};

export const GasCircleTwoRow = (props: Props) => {
  const { className, show, gasStore, showArrow, onClickArrow } = props;
  const fm = useFm();
  return (
    <Row
      className={cls(className, styles.twoRow)}
      show={show}
      label={fm('estimated_cost')}
      value={
        <div className={styles.gasfeeTwoRow}>
          <Circle
            className={styles.circleTwoRow}
            percent={gasStore.loopPercent}
            trailWidth={10}
            strokeWidth={10}
            trailColor="rgba(247, 166, 0, 0.16)"
            strokeColor="#F7A600"
          />
          <div>
            <div
              className={styles.amount}
            >{`${gasStore.amount} ${gasStore.symbol}`}</div>
            <div className={styles.price}>
              {`${formatUSDYield(gasStore.price)}`}
            </div>
          </div>
        </div>
      }
      showArrow={showArrow}
      onClickArrow={onClickArrow}
    />
  );
};
